import React from "react";
import BusDetailsCard from "./BusDetailsCard";

export default function Bus8() {
  return (
    <BusDetailsCard
      busId="bus8"
      title="Bus 8 - Route Details"
      busName="Bus 8"
      vehicleNo="TN74H8234"
      backTo="/?buses=1"
    />
  );
}